import { Truck } from 'lucide-react';

export default function AnnouncementBar() {
  return (
    <div className="bg-[#354F52] text-[#FAF9F6] text-xs sm:text-sm overflow-hidden" data-testid="announcement-bar">
      <div className="container-custom px-6 md:px-12 lg:px-24 py-2.5">
        <div className="flex items-center justify-center gap-2 sm:gap-6 text-center">
          <span className="flex items-center gap-2">
            <Truck className="w-3.5 h-3.5 text-[#D4AF37] hidden sm:inline" strokeWidth={1.5} />
            <span>
              <span className="hidden sm:inline">Free shipping in Cyprus · </span>
              10% off your first order with code{' '}
              <span className="text-[#D4AF37] font-medium tracking-wider">WELCOME10</span>
            </span>
          </span>
          <span className="hidden md:inline text-[#84A98C]">·</span>
          <span className="hidden md:inline text-[#CAD2C5]">Handmade in Cyprus</span>
        </div>
      </div>
    </div>
  );
}
